import {useRef} from "react";
import isEqual from "lodash/isEqual";

export function useDeepMemo(value, dependencies) {
  const ref = useRef();

  if (!ref.current || !isEqual(ref.current.dependencies, dependencies)) {
    ref.current = {
      dependencies,
      value,
    };
  }

  return ref.current.value;
}